<template>
  <div class="tabs">
    <nav v-show="tabs.length > 1">
      <button @click="scroll(true)" v-if="!isLeft"><arrow></arrow></button>
      <div class="scroll-container" ref="scrollContainer">
        <ul>
          <li
            v-for="(tab, index) in tabs"
            :key="tab.title"
            @click="selectTab(index)"
            :class='{"selected": (index === selectedIndex)}'
          >
            <button :ref="`tab-${tab.id}`" v-text="tab.title"></button>
          </li>
        </ul>
      </div>
      <button v-if="!isRight" @click="scroll()"><arrow></arrow></button>
    </nav>
    <slot></slot>
  </div>
</template>

<script>
import Arrow from './icons/Arrow.vue';
import { storeHash, loadHash } from '../State';

export default {
  name: 'Tabs',
  data: () => ({
    selectedIndex: 0,
    childs: [],
    isLeft: true,
    isRight: true,
    textDirection: 'ltr',
  }),
  computed: {
    tabs() {
      return this.childs.filter((c) => (c.id && c.title));
    },
  },
  methods: {
    debounce(callback) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(callback, 100);
    },
    selectInitial() {
      const toBeSelected = this.tabs.findIndex((t) => t.title === loadHash('tab'));
      this.selectTab(Math.max(0, toBeSelected));
    },
    scrollToSelectedTab() {
      setTimeout(() => {
        const tab = this.$refs[`tab-${this.tabs[this.selectedIndex].id}`][0];
        const centeredNav = this.$refs.scrollContainer.offsetWidth / 2;
        const centeredTab = tab.offsetWidth / 2;
        const margin = 36;
        this.$refs.scrollContainer.scrollTo({
          left: tab.offsetLeft + margin - centeredNav + centeredTab,
          behavior: 'smooth',
        });
      }, 250);
    },
    scroll(left = false) {
      const delta = 50;
      // const logicalLeft = (this.textDirection === 'rtl') ? !left : left;
      this.$refs.scrollContainer.scrollTo({
        left: this.$refs.scrollContainer.scrollLeft + (left ? -1 * delta : delta),
        behavior: 'smooth',
      });
    },
    selectTab(i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        // eslint-disable-next-line no-param-reassign
        tab.isActive = (index === i);
      });
      this.scrollToSelectedTab();
      storeHash('tab', this.tabs[this.selectedIndex].title);
      this.$emit('tab-selected', this.selectedIndex);
    },
    handleDisplayOfArrows() {
      this.debounce(() => {
        if (this.textDirection === 'rtl') {
          this.isRight = this.$refs.scrollContainer.scrollLeft >= 0;
          this.isLeft = this.$refs.scrollContainer.offsetWidth - this.$refs.scrollContainer.scrollWidth >= this.$refs.scrollContainer.scrollLeft;
        } else {
          this.isLeft = this.$refs.scrollContainer.scrollLeft <= 0;
          this.isRight = this.$refs.scrollContainer.scrollWidth - this.$refs.scrollContainer.offsetWidth <= this.$refs.scrollContainer.scrollLeft;
        }
      });
    },
    reactToUserInteraction() {
      this.$refs.scrollContainer.addEventListener('scroll', () => {
        this.handleDisplayOfArrows();
      });
      window.addEventListener('resize', () => {
        this.handleDisplayOfArrows();
      });
      // on page load...
      this.handleDisplayOfArrows();
    },
  },
  mounted() {
    this.selectInitial();
    this.reactToUserInteraction();
  },
  created() {
    this.textDirection = document.querySelector('html').getAttribute('dir') || 'ltr';
    this.childs = this.$children;
  },
  components: { Arrow },
};
</script>

<style scoped lang="scss">
.tabs {
  width: calc(100% + #{$main-padding-s} * 2);
  margin-right: -$main-padding-s;
  margin-left: -$main-padding-s;
  padding-right: $main-padding-s;
  padding-left: $main-padding-s;

  @include media-breakpoint-up(m) {
    width: calc(100% + #{$main-padding-m} * 2);
    margin-right: -$main-padding-m;
    margin-left: -$main-padding-m;
    padding-right: $main-padding-m;
    padding-left: $main-padding-m;
  }

  @include media-breakpoint-up(l) {
    width: calc(100% + #{$main-padding-l} * 2);
    margin-right: -$main-padding-l;
    margin-left: -$main-padding-l;
    padding-right: $main-padding-l;
    padding-left: $main-padding-l;
  }
}
nav {
  position: relative;

  .scroll-container {
    overflow: hidden;
    display: flex;
    overflow-x: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }

  > button {
    border: none;
    margin: 0;
    padding: 0;
    width: 20px;
    position: absolute;
    top: 0;
    background-color: $color-kws-black-5;
    opacity: .75;

    .bg-white & {
      background-color: $color-white;
    }
  }

  > button:first-child {
    display: block;
    left: -$main-padding-s;
    svg {
      transform: rotate(90deg);
      width: 100%;
      height: 100%;
    }
  }

  > button:last-child {
    display: block;
    left: calc(100% + 11px);
    svg {
      transform: rotate(270deg);
      width: 100%;
      height: 100%;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
    display: flex;

    li {
      display: flex;
      width: auto;

      button {
        border: 0;
        background-color: transparent;
        display: flex;
        align-items: center;
        height: 2.5rem;
        white-space: nowrap;
        padding-bottom: 0.875rem;
        border-bottom: 0.25rem solid transparent;
        color: #333;
        text-decoration: none;
        font-weight: 400;
        cursor: pointer;
        margin-right: 2rem;
      }

      &.selected button {
        border-bottom-color: #ff6c00;
        text-decoration: none;
      }

      &:last-child button {
        margin-right: 0;
      }
    }
  }
}
</style>
